import { DEFAULTS } from "./defaults.js";
import { LINK_PREVIEW_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginLinkPreview = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINK_PREVIEW_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginLinkPreview
};
//# sourceMappingURL=viewer.js.map
